import React, { useState } from 'react'
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import Select from 'react-select';


export const GlobalFormPatient = (props) => {

    const {

        // ? ACTIONS OF THE INPUTS
        handleInputChange, handleSelectValues, handleChangeState, handleChangeTaxRegime, handleChangeSocialGender, handleDateB, getAge,
        handleChangeTypePerson,

        // ? FIELD
        id_gender, id_state, id_municipality, id_blood_type, id_social_gender, id_tax_regime,
        id_use_cfdi, rfc, paternal_surname, maternal_surname, name, birthday, age,
        curp, address, cp, colony, phone, email, membership, cardnumber, expedient_number, nss, matricula_buap, type_person, hospitalized,

        // ? CATALOGS
        listStates, listMunicipalities, listBloodType, listTaxRegime, listUseCfdi, listSocialGender,

        // ? DYNAMIC FORM
        listConfiguration, fieldErrors, whatsapp_numbers, handleWhatsappChange, validateWhatsapp


    } = props;


    const isVisible = (fieldName) => {
        return listConfiguration?.some(x => x.field === fieldName);
    };

    const isRequired = (fieldName) => {
        return listConfiguration?.find(x => x.field === fieldName)?.required_field;
    };

    const getFieldLabel = (fieldName) => {
        return listConfiguration?.find(x => x.field === fieldName)?.field_name || fieldName;
    };

    const enableWhatsapp = localStorage.getItem("enable_whatsapp") === "True";

    return (
        <>
            <Col sm="12" className='pt-2 ' >


                <div className={isVisible("name") ? "form-section" : "d-none"}>

                    <h6 className="section-title">
                        <i className="fa fa-user"></i>
                        Información Personal
                    </h6>

                    <small className="section-warning-absolute">
                        <i className="fa fa-exclamation-circle me-1"></i>&nbsp;
                        Complete los campos requeridos
                    </small>

                    <Row className="g-4">
                        {isVisible("name") && (
                            <Col sm="12" md="3">
                                <FormGroup>
                                    <Label className="label-admision">
                                        {getFieldLabel("name")}
                                        {isRequired("name") && <span className="required f-16">*</span>}
                                    </Label>
                                    <Input
                                        type="text"
                                        name="name"
                                        value={name}
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        className="input-admision"
                                        invalid={fieldErrors[`${"name"}_valid`] || false}
                                    />

                                    {fieldErrors[`${"name"}_valid`] && (
                                        <small className="error-text">
                                            <i className="pi pi-exclamation-circle error-icon"></i>
                                            Ingrese un nombre válido
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                        )}


                        {isVisible("paternal_surname") && (
                            <Col sm="12" md="3">
                                <FormGroup>
                                    <Label className="label-admision">
                                        {getFieldLabel("paternal_surname")}
                                        {isRequired("paternal_surname") && <span className="required f-16">*</span>}
                                    </Label>
                                    <Input
                                        type="text"
                                        name="paternal_surname"
                                        value={paternal_surname}
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        invalid={fieldErrors[`${"paternal_surname"}_valid`] || false}
                                        className="input-admision"
                                    />

                                    {fieldErrors[`${"paternal_surname"}_valid`] && (
                                        <small className="error-text">
                                            <i className="pi pi-exclamation-circle error-icon"></i>
                                            Ingrese un apellido válido
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                        )}

                        {isVisible("maternal_surname") && (
                            <Col sm="12" md="3">
                                <FormGroup>
                                    <Label className="label-admision">
                                        {getFieldLabel("maternal_surname")}
                                        {isRequired("maternal_surname") && <span className="required f-16">*</span>}
                                    </Label>
                                    <Input
                                        type="text"
                                        name="maternal_surname"
                                        value={maternal_surname}
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        className="input-admision"
                                        invalid={fieldErrors[`${"maternal_surname"}_valid`] || false}
                                    />

                                    {fieldErrors[`${"maternal_surname"}_valid`] && (
                                        <small className="error-text">
                                            <i className="pi pi-exclamation-circle error-icon"></i>
                                            Ingrese un apellido válido
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                        )}

                        {isVisible("curp") && (
                            <Col sm="12" md="3">
                                <FormGroup>
                                    <Label className="label-admision">
                                        {getFieldLabel("curp")}
                                        {isRequired("curp") && <span className="required f-16">*</span>}
                                    </Label>
                                    <Input
                                        type="text"
                                        name="curp"
                                        value={curp}
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        className="input-admision"
                                        invalid={fieldErrors[`${"curp"}_valid`] || false}
                                    />

                                    {fieldErrors[`${"curp"}_valid`] && (
                                        <small className="error-text">
                                            <i className="pi pi-exclamation-circle error-icon"></i>
                                            Ingrese una curp válida
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                        )}

                        {isVisible("birthday") && (
                            <Col sm="12" md="3">
                                <FormGroup>
                                    <Label className="label-admision">
                                        {getFieldLabel("birthday")}
                                        {isRequired("birthday") && <span className="required f-16">*</span>}
                                    </Label>
                                    <Input
                                        type="date"
                                        name="birthday"
                                        value={birthday}
                                        onChange={(e) => handleDateB(e.target.value)}
                                        invalid={fieldErrors[`${"birthday"}_valid`] || false}
                                        className="input-admision"
                                    />

                                    {fieldErrors[`${"birthday"}_valid`] && (
                                        <small className="error-text">
                                            <i className="pi pi-exclamation-circle error-icon"></i>
                                            Ingrese la fecha
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                        )}

                        {isVisible("age") && (
                            <Col sm="12" md="3">
                                <FormGroup>
                                    <Label className="label-admision">
                                        {getFieldLabel("age")}
                                        {isRequired("age") && <span className="required f-16">*</span>}
                                    </Label>
                                    <Input
                                        className="input-admision"
                                        type="number"
                                        min={0}
                                        max={110}
                                        name="age"
                                        value={age}
                                        onChange={(e) => getAge(e.target.value)}
                                        invalid={fieldErrors[`${"age"}_valid`] || false}
                                    />

                                    {fieldErrors[`${"age"}_valid`] && (
                                        <small className="error-text">
                                            <i className="pi pi-exclamation-circle error-icon"></i>
                                            Ingrese una edad valida
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                        )}

                        {isVisible("id_gender") && (
                            <Col sm="12" md="3">
                                <FormGroup>
                                    <Label className="label-admision">
                                        {getFieldLabel("id_gender")}
                                        {isRequired("id_gender") && <span className="required f-16">*</span>}
                                    </Label>
                                    <Input className="input-admision" type='select' name="id_gender" onChange={handleInputChange} value={id_gender}
                                        invalid={fieldErrors[`${"id_gender"}_valid`] || false}
                                    >
                                        <option value={0}>Selecciona una opción</option>
                                        <option value={1}>Femenino</option>
                                        <option value={2}>Masculino</option>
                                    </Input>

                                    {fieldErrors[`${"id_gender"}_valid`] && (
                                        <small className="error-text">
                                            <i className="pi pi-exclamation-circle error-icon"></i>
                                            Ingrese un genero
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                        )}

                        {isVisible("id_social_gender") && (
                            <Col sm="12" md="3">
                                <FormGroup>
                                    <Label className="label-admision">
                                        {getFieldLabel("id_social_gender")}
                                        {isRequired("id_social_gender") && <span className="required f-16">*</span>}
                                    </Label>
                                    <Select
                                        name="id_social_gender"
                                        value={id_social_gender}
                                        isClearable
                                        placeholder="Selecciona una opción"
                                        options={listSocialGender}
                                        onChange={handleChangeSocialGender}
                                        invalid={fieldErrors[`${"id_social_gender"}_valid`] || false}
                                    />

                                    {fieldErrors[`${"id_social_gender"}_valid`] && (
                                        <small className="error-text">
                                            <i className="pi pi-exclamation-circle error-icon"></i>
                                            Ingrese un dato valido
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                        )}


                        {isVisible("id_blood_type") && (
                            <Col sm="12" md="3">
                                <FormGroup>
                                    <Label className="label-admision">
                                        {getFieldLabel("id_blood_type")}
                                        {isRequired("id_blood_type") && <span className="required f-16">*</span>}
                                    </Label>
                                    <Select
                                        name="id_blood_type"
                                        value={id_blood_type}
                                        isClearable
                                        placeholder="Seleccionar"
                                        options={listBloodType}
                                        onChange={(e) => handleSelectValues(e, "id_blood_type")}
                                        classNamePrefix="input-admision"
                                        invalid={fieldErrors[`${"id_blood_type"}_valid`] || false}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                fontSize: "12px",
                                            }),
                                            option: (base) => ({
                                                ...base,
                                                fontSize: "12px",
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                fontSize: "12px",
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: "12px",
                                            }),
                                            input: (base) => ({
                                                ...base,
                                                fontSize: "12px",
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999999,
                                            }),
                                        }}
                                    />

                                    {fieldErrors[`${"id_blood_type"}_valid`] && (
                                        <small className="error-text">
                                            <i className="pi pi-exclamation-circle error-icon"></i>
                                            Ingrese un tipo de sangre
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                        )}

                        {isVisible("phone") && (
                            <Col sm="12" md="3">
                                <FormGroup>
                                    <Label className="label-admision">
                                        {getFieldLabel("phone")}
                                        {isRequired("phone") && <span className="required f-16">*</span>}
                                    </Label>
                                    <Input type='tel' name='phone' value={phone} autoComplete='off'
                                        invalid={fieldErrors[`${"phone"}_valid`] || false}
                                        onChange={handleInputChange} className="input-admision" />

                                    {fieldErrors[`${"phone"}_valid`] && (
                                        <small className="error-text">
                                            <i className="pi pi-exclamation-circle error-icon"></i>
                                            Ingrese un teléfono valido
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                        )}

                        {isVisible("email") && (
                            <Col sm="12" md="3">
                                <FormGroup>
                                    <Label className="label-admision">
                                        {getFieldLabel("email")}
                                        {isRequired("email") && <span className="required f-16">*</span>}
                                    </Label>
                                    <Input
                                        type="text"
                                        name="email"
                                        value={email}
                                        autoComplete="off"
                                        onChange={handleInputChange}
                                        className="input-admision"
                                        invalid={fieldErrors[`${"email"}_valid`] || false}
                                    />

                                    {fieldErrors[`${"email"}_valid`] && (
                                        <small className="error-text">
                                            <i className="pi pi-exclamation-circle error-icon"></i>
                                            Ingrese un correo valido
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                        )}

                        {isVisible("membership") && (
                            <Col sm="12" md="3">
                                <FormGroup>
                                    <Label className="label-admision">
                                        {getFieldLabel("membership")}
                                        {isRequired("membership") && <span className="required f-16">*</span>}
                                    </Label>
                                    <Input type='text' autoComplete='off' className="input-admision" name='membership'
                                        invalid={fieldErrors[`${"membership"}_valid`] || false}
                                        value={membership} onChange={handleInputChange} />

                                    {fieldErrors[`${"membership"}_valid`] && (
                                        <small className="error-text">
                                            <i className="pi pi-exclamation-circle error-icon"></i>
                                            Ingrese un dato
                                        </small>
                                    )}

                                </FormGroup>
                            </Col>
                        )}

                        {isVisible("matricula_buap") && (
                            <Col sm="12" md="3">
                                <FormGroup>
                                    <Label className="label-admision">
                                        {getFieldLabel("matricula_buap")}
                                        {isRequired("matricula_buap") && <span className="required f-16">*</span>}
                                    </Label>
                                    <Input
                                        type="text"
                                        name='matricula_buap'
                                        value={matricula_buap}
                                        autoComplete='off'
                                        onChange={handleInputChange}
                                        className="input-admision"
                                        invalid={fieldErrors[`${"matricula_buap"}_valid`] || false}
                                    />

                                    {fieldErrors[`${"matricula_buap"}_valid`] && (
                                        <small className="error-text">
                                            <i className="pi pi-exclamation-circle error-icon"></i>
                                            Ingrese una matrícula
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                        )}

                        {isVisible("hospitalized") && (
                            <Col sm="12" md="3">
                                <FormGroup>
                                    <Label className="label-admision">
                                        {getFieldLabel("hospitalized")}
                                    </Label>

                                    <Label className="switch">
                                        <Input
                                            type="checkbox"
                                            name="hospitalized"
                                            onChange={handleInputChange}
                                            checked={hospitalized === true || hospitalized === 1}
                                        />
                                        <span className="slider round"></span>
                                    </Label>
                                </FormGroup>
                            </Col>

                            
                        )}



                        {isVisible("whatsapp_numbers") && enableWhatsapp && (
                            <Col sm="12" md="3">
                                <FormGroup>
                                    <Label className="label-admision">
                                        {getFieldLabel("whatsapp_numbers")}
                                        {isRequired("whatsapp_numbers") && <span className="required f-16">*</span>}

                                        <span style={{ color: "#3d81e5", fontSize: "12px", marginLeft: "6px" }}>
                                            (En caso de más de un teléfono, sepárelos con ",")
                                        </span>
                                    </Label>

                                    <Input
                                        type='text'
                                        autoComplete='off'
                                        className="input-admision"
                                        name='whatsapp_numbers'
                                        invalid={fieldErrors["whatsapp_numbers_valid"] || false}
                                        value={whatsapp_numbers}
                                        onChange={handleWhatsappChange}
                                        onBlur={validateWhatsapp}
                                    />

                                    {fieldErrors["whatsapp_numbers_valid"] && (
                                        <small className="error-text">
                                            <i className="pi pi-exclamation-circle error-icon"></i>
                                            Debe ingresar un número de teléfono de 10 dígitos.
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                        )}
                        
                        {isVisible("expedient_number") && (
                            <Col sm="12" md="3">
                                <FormGroup>
                                    <Label className="label-admision">
                                        {getFieldLabel("expedient_number")}
                                        {isRequired("expedient_number") && <span className="required f-16">*</span>}
                                    </Label>
                                    <Input type='expedient_number' invalid={fieldErrors[`${"expedient_number"}_valid`] || false}
                                        name='expedient_number' value={expedient_number} autoComplete='off' onChange={handleInputChange}
                                        className="input-admision" />

                                    {fieldErrors[`${"expedient_number"}_valid`] && (
                                        <small className="error-text">
                                            <i className="pi pi-exclamation-circle error-icon"></i>
                                            Ingrese un número de expediente
                                        </small>
                                    )}
                                </FormGroup>
                            </Col>
                        )}
                    </Row>
                </div>


                {(isVisible("email") || isVisible("cp")) && (
                    <div className="form-section">
                        <h6 className="section-title">
                            <i className="pi pi-map-marker"></i>
                            Ubicación y Contacto
                        </h6>

                        <Row className="g-4">

                            {isVisible("address") && (
                                <Col sm="12" md="3">
                                    <FormGroup>
                                        <Label className="label-admision">
                                            {getFieldLabel("address")}
                                            {isRequired("address") && <span className="required f-16">*</span>}
                                        </Label>
                                        <Input type='text' name='address' invalid={fieldErrors[`${"address"}_valid`] || false}
                                            value={address} autoComplete='off' onChange={handleInputChange} className="input-admision"
                                        />

                                        {fieldErrors[`${"address"}_valid`] && (
                                            <small className="error-text">
                                                <i className="pi pi-exclamation-circle error-icon"></i>
                                                Ingrese el dato
                                            </small>
                                        )}
                                    </FormGroup>
                                </Col>
                            )}


                            {isVisible("colony") && (
                                <Col sm="12" md="3">
                                    <FormGroup>
                                        <Label className="label-admision">
                                            {getFieldLabel("colony")}
                                            {isRequired("colony") && <span className="required f-16">*</span>}
                                        </Label>
                                        <Input type='text' name='colony' invalid={fieldErrors[`${"colony"}_valid`] || false}
                                            value={colony} autoComplete='off' onChange={handleInputChange} className="input-admision"
                                        />

                                        {fieldErrors[`${"colony"}_valid`] && (
                                            <small className="error-text">
                                                <i className="pi pi-exclamation-circle error-icon"></i>
                                                Ingrese el dato
                                            </small>
                                        )}
                                    </FormGroup>
                                </Col>
                            )}



                            {isVisible("cp") && (
                                <Col sm="12" md="1" className='pl-0 pr-0' >
                                    <FormGroup>
                                        <Label className="label-admision">
                                            {getFieldLabel("cp")}
                                            {isRequired("cp") && <span className="required f-16">*</span>}
                                        </Label>
                                        <Input
                                            type="number"
                                            name="cp"
                                            value={cp}
                                            autoComplete="off"
                                            onChange={handleInputChange}
                                            className="input-admision"
                                            invalid={fieldErrors[`${"cp"}_valid`] || false}
                                        />

                                        {fieldErrors[`${"cp"}_valid`] && (
                                            <small className="error-text">
                                                <i className="pi pi-exclamation-circle error-icon"></i>
                                                Ingrese un código postal valido
                                            </small>
                                        )}
                                    </FormGroup>
                                </Col>
                            )}



                            {isVisible("id_state") && (
                                <Col sm="12" md="2" className='pr-0' >
                                    <FormGroup>
                                        <Label className="label-admision">
                                            {getFieldLabel("id_state")}
                                            {isRequired("id_state") && <span className="required f-16">*</span>}
                                        </Label>
                                        <Select
                                            name="id_state"
                                            value={id_state}
                                            isClearable={true}
                                            placeholder="Seleccionar"
                                            options={listStates}
                                            onChange={(e) => handleChangeState(e)}
                                            menuPortalTarget={document.body}
                                             styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    fontSize: "12px",
                                                }),
                                                option: (base) => ({
                                                    ...base,
                                                    fontSize: "12px",
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    fontSize: "12px",
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    fontSize: "12px",
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    fontSize: "12px",
                                                }),
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999999,
                                                }),
                                            }}
                                            classNamePrefix="input-admision"
                                            invalid={fieldErrors[`${"id_state"}_valid`] || false}
                                        />

                                        {fieldErrors[`${"id_state"}_valid`] && (
                                            <small className="error-text">
                                                <i className="pi pi-exclamation-circle error-icon"></i>
                                                Ingrese un estado valido
                                            </small>
                                        )}
                                    </FormGroup>
                                </Col>
                            )}


                            {isVisible("id_municipality") && (
                                <Col sm="12" md="3">
                                    <FormGroup>
                                        <Label className="label-admision">
                                            {getFieldLabel("id_municipality")}
                                            {isRequired("id_municipality") && <span className="required f-16">*</span>}
                                        </Label>
                                        <Select
                                            name="id_municipality"
                                            value={id_municipality}
                                            isClearable={true}
                                            placeholder="Seleccionar"
                                            options={listMunicipalities}
                                            onChange={(e) => handleSelectValues(e, "id_municipality")}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    fontSize: "12px",
                                                }),
                                                option: (base) => ({
                                                    ...base,
                                                    fontSize: "12px",
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    fontSize: "12px",
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    fontSize: "12px",
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    fontSize: "12px",
                                                }),
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999999,
                                                }),
                                            }}
                                            classNamePrefix="input-admision"
                                            invalid={fieldErrors[`${"id_municipality"}_valid`] || false}
                                        />

                                        {fieldErrors[`${"id_municipality"}_valid`] && (
                                            <small className="error-text">
                                                <i className="pi pi-exclamation-circle error-icon"></i>
                                                Ingrese un municipio valido
                                            </small>
                                        )}
                                    </FormGroup>
                                </Col>
                            )}
                        </Row>
                    </div>
                )}




                {(isVisible("unique_uuid") ||
                    isVisible("")) && (
                        <div className="form-section">
                            <h6 className="section-title">
                                <i className="fa fa-id-card"></i>
                                Otros datos
                            </h6>

                            <Row className="g-4">

                                {isVisible("unique_uuid") && (
                                    <Col sm="12" md="3">
                                        <FormGroup>
                                            <Label className="label-admision">
                                                {getFieldLabel("unique_uuid")}
                                                {isRequired("unique_uuid") && <span className="required f-16">*</span>}
                                            </Label>
                                            <Input invalid={fieldErrors[`${"unique_uuid"}_valid`] || false}
                                                type='text' autoComplete='off' className="input-admision" name='cardnumber' value={cardnumber}
                                                onChange={handleInputChange} />

                                            {fieldErrors[`${"unique_uuid"}_valid`] && (
                                                <small className="error-text">
                                                    <i className="pi pi-exclamation-circle error-icon"></i>
                                                    Ingrese un dato valido
                                                </small>
                                            )}
                                        </FormGroup>
                                    </Col>
                                )}




                                {isVisible("nss") && (
                                    <Col sm="12" md="3">
                                        <FormGroup>
                                            <Label className="label-admision">
                                                {getFieldLabel("nss")}
                                                {isRequired("nss") && <span className="required f-16">*</span>}
                                            </Label>
                                            <Input
                                                type='text'
                                                name='nss'
                                                value={nss}
                                                autoComplete='off'
                                                maxLength={30}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (value.length > 0 && value.length <= 30) {
                                                        handleInputChange(e);
                                                    }
                                                }}
                                                className="input-admision"
                                                invalid={fieldErrors[`${"nss"}_valid`] || false}
                                            />

                                            {fieldErrors[`${"nss"}_valid`] && (
                                                <small className="error-text">
                                                    <i className="pi pi-exclamation-circle error-icon"></i>
                                                    Ingrese un dato valido
                                                </small>
                                            )}
                                        </FormGroup>
                                    </Col>
                                )}
                            </Row>
                        </div>
                    )}


                {(isVisible("rfc") ||
                    isVisible("id_tax_regime")) && (

                        <div className="form-section">
                            <h6 className="section-title">
                                <i className="pi pi-file-pdf"></i>
                                Datos de Facturación
                            </h6>

                            <Row className="g-4">

                                {isVisible("type_person") && (
                                    <Col sm="12" md="3">
                                        <FormGroup>
                                            <Label className="label-admision">
                                                {getFieldLabel("type_person")}
                                                {isRequired("type_person") && <span className="required f-16">*</span>}
                                            </Label>
                                            <Input type="select" name='type_person' value={type_person} onChange={(e) => handleChangeTypePerson(e)} className="input-admision">
                                                <option value="1">Física</option>
                                                <option value="2">Moral</option>
                                            </Input>

                                            {fieldErrors[`${"type_person"}_valid`] && (
                                                <small className="error-text">
                                                    <i className="pi pi-exclamation-circle error-icon"></i>
                                                    Ingrese un dato valido
                                                </small>
                                            )}
                                        </FormGroup>
                                    </Col>
                                )}






                                {isVisible("rfc") && (
                                    <Col sm="12" md="3">
                                        <FormGroup>
                                            <Label className="label-admision">
                                                {getFieldLabel("rfc")}
                                                {isRequired("rfc") && <span className="required f-16">*</span>}
                                            </Label>
                                            <Input type='text' name="rfc" value={rfc} className="input-admision" onChange={handleInputChange}
                                                invalid={fieldErrors[`${"rfc"}_valid`] || false}
                                                placeholder='XAXX010101000' />

                                            {fieldErrors[`${"rfc"}_valid`] && (
                                                <small className="error-text">
                                                    <i className="pi pi-exclamation-circle error-icon"></i>
                                                    Ingrese un dato valido
                                                </small>
                                            )}
                                        </FormGroup>
                                    </Col>
                                )}


                                {isVisible("id_tax_regime") && (
                                    <Col sm="12" md="3">
                                        <FormGroup>
                                            <Label className="label-admision">
                                                {getFieldLabel("id_tax_regime")}
                                                {isRequired("id_tax_regime") && <span className="required f-16">*</span>}
                                            </Label>
                                            <Select
                                                name="id_tax_regime"
                                                value={id_tax_regime}
                                                isClearable={true}
                                                placeholder="Selecciona una opción"
                                                options={listTaxRegime}
                                                className="input-air-primary input-sm"
                                                onChange={(e) => handleChangeTaxRegime(e)}
                                                classNamePrefix="input-admision"
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999999 }) }}
                                            />
                                        </FormGroup>
                                    </Col>
                                )}

                                {isVisible("id_use_cfdi") && (
                                    <Col sm="12" md="3">
                                        <FormGroup>
                                            <Label className="label-admision">
                                                {getFieldLabel("id_use_cfdi")}  {isRequired("id_use_cfdi") && <span className="required f-16">*</span>}
                                            </Label>
                                            <Select
                                                name="id_use_cfdi"
                                                value={id_use_cfdi}
                                                isClearable={true}
                                                placeholder="Selecciona una opción"
                                                options={listUseCfdi}
                                                className="input-air-primary input-sm"
                                                onChange={(e) => handleSelectValues(e, "id_use_cfdi")}
                                                classNamePrefix="input-admision"
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999999 }) }}
                                            />
                                        </FormGroup>
                                    </Col>
                                )}
                            </Row>
                        </div>
                    )}
            </Col >
        </>
    )
}